<template>
  <div>
    <div v-if="!isLoading" class="event-body">
      <div class="wrap">
        <div class="event-detail-top">
          <h3 class="event-d-tit" tabindex="0">{{ eventTitle }}</h3>
          <p class="event-d-date">{{ startDate }} ~ {{ endDate }}</p>
          <a
            href="javascript:void(0)"
            @click.prevent="moveList(prevPage)"
            class="event-list-btn"
          >
            <img :src="require('@/assets/images/event/icon-table-listback.png')" alt="목록 아이콘">
            <span>목록</span>
          </a>
        </div>
        <div class="event-desc">

          <!-- event description image -->
          <div class="event-desc-img">
            <img v-if="eventPosterImage" :src="getImage(eventPosterImage)" :alt="setAlt()">
            <div v-else class="min-h-screen"></div>
          </div>

          <!-- related event contents -->
          <EventContentList
            v-if="eventContentList.length"
            :event-content-list="eventContentList"
            :content-type="contentType"
          />
        </div>
      </div>
    </div>
    <div v-else class="min-h-screen"></div>

    <PagingComponent
      v-if="eventContentList && eventContentList.length > 0"
      :current-page="currentPage"
      :page-count="+pageCount"
      :limit="limit"
      :paging-couunt="pagingCnt"
      wrapper-class="paging-type02"
    />

  </div>
</template>

<script>
import PagingComponent from '@/components/common/PagingComponent'
import EventContentList from '@/components/customer/EventContentList.vue'
import { getEventsDetail, getEventsContents } from '@/common/utils/request'
import { imageUrl } from '@/common/filters/url.filter'
import { scrollTop, titleTagNameChange } from '@/common/utils/common'
import _ from 'lodash'
import { resizeThumbnail } from '@/common/utils/image'

export default {
  name: 'EventViewPage',
  components: {
    EventContentList,
    PagingComponent
  },
  filters: {
    imageUrl
  },
  data () {
    return {
      eventId: '',
      currentPage: 1,
      prevPage: '1',
      eventDetailData: {},
      eventContentList: [],
      pageCount: 0,
      limit: 10,
      pagingCnt: 10,
      isLoading: true
    }
  },
  computed: {
    eventTitle () {
      return this.eventDetailData?.eventtitle ?? '이벤트'
    },
    eventPosterImage () {
      return this.eventDetailData.detailimage ?? ''
    },
    startDate () {
      return this.eventDetailData?.startdate ?? ''
    },
    endDate () {
      return this.eventDetailData?.enddate ?? ''
    },
    contentType () {
      return this.eventDetailData?.contenttype ?? ''
    }
  },
  methods: {
    getImage (url) {
      return resizeThumbnail(url, { width: 0, height: 0, option: 20, quality: 80 })
    },
    setAlt () {
      const { gift = '', eventtitle, description, startdate, enddate, announcementdate } = this.eventDetailData
      const defaultAlt = `${eventtitle} ${description} 기간은 ${startdate}부터 ${enddate}까지 입니다.`
      const giftAlt = gift.length > 0 ? ` 이벤트 경품은 ${gift}입니다. 당첨자 발표일은 ${announcementdate}입니다.` : ''
      return defaultAlt + giftAlt
    },
    moveList (prevPage) {
      this.$router.push({
        name: 'event_list',
        query: {
          page: prevPage
        }
      })
    },
    initialise () {
      this.eventId = _.get(this.$route, ['query', 'eventId'], '')
      this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
      this.prevPage = Number(_.get(this.$route, ['query', 'prevPage'], '1'))
    },
    async setData () {
      if (this.eventId) {
        this.isLoading = true
        let offset = this.limit * (this.currentPage - 1)
        try {
          // event 상세 페이지 데이터
          const { data: eventDetailRes } = await getEventsDetail({ eventid: this.eventId })
          this.eventDetailData = eventDetailRes

          // event 연관 콘텐츠 리스트 데이터
          const { data: eventContentRes } = await getEventsContents({ eventid: this.eventId, contenttype: this.contentType, offset, limit: this.limit })
          const [ eventData ] = eventContentRes
          const { list = [], pagecount: pageCount = '0' } = eventData
          this.eventContentList = list

          titleTagNameChange(`${this.eventTitle} : 웨이브 이벤트`)

          this.pageCount = Number(pageCount)
          this.isLoading = false

          scrollTop()
        } catch (e) {
          console.error(e)
        }
      }
    }
  },
  created () {
    this.initialise()
    this.setData()
  },
  watch: {
    $route () {
      this.initialise()
      this.setData()
    }
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/event.scss"></style>
